import { useNavigate } from 'react-router-dom';
import { GoPencil } from "react-icons/go";
import styles from "../CardUsuario/cardUsuario.module.css";

export interface Usuariocard {
    id: string;
    name: string;
    email: string;
    cpf: string;
    telefone: string;
    imagem: string | null;
}

const UsuarioItem = ({ usuario, showButton = false }: { usuario: Usuariocard, showButton?: boolean}) => {
    const { name, cpf, email, telefone, imagem } = usuario;

    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/auth/client/account/profile/edit');
    };

    return (
        <div className={styles.usuarioC}>
            {imagem && <img src={imagem} alt={name} className={styles.usuarioIm} />}
            <div className={styles.usuarioI}>
                <div className={styles.nameDiv}>
                    <p><strong>NOME:</strong></p>
                    <span className={styles.name}>{name}</span>
                    {showButton && (
                        <button className={styles.pencilButton} onClick={handleButtonClick}>
                            <GoPencil className={styles.pencilIcon} />
                        </button>
                    )}
                </div>
                <div className={styles.naonome}>
                    <div>
                        <p><strong>CPF:</strong></p>
                        <span>{cpf}</span>
                    </div>
                    <div>
                        <p><strong>EMAIL:</strong></p>
                        <span>{email}</span>
                    </div>
                    <div>
                        <p><strong>TELEFONE:</strong></p>
                        <span>{telefone}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsuarioItem;
